import { render, staticRenderFns } from "./AcceptApprovalFormModal.vue?vue&type=template&id=77d4a836&scoped=true&"
import script from "./AcceptApprovalFormModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AcceptApprovalFormModal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./AcceptApprovalFormModal.vue?vue&type=style&index=0&id=77d4a836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d4a836",
  null
  
)

export default component.exports